import { useEffect, useState } from 'react'
import { type FormattedAvailableDay } from '~/features/schedules/getAllFormattedAvailableDatesOfMonth.ts'
import { buildQueryParams } from '~/utils/objects.ts'
import { type Session } from '@prisma/client'
import { useHints } from '~/utils/client-hints.tsx'
import { type ServiceWithProfesional } from '~/components/dialogs/schedule-session-dialog.tsx'

interface Props {
  service: ServiceWithProfesional
  sessionToReschedule?: Session
}

interface MonthAndYear {
  month: number
  year: number
}

function useMontlyParsedDates({ service, sessionToReschedule }: Props) {
  const [availableDates, setAvailableDates] = useState<FormattedAvailableDay[]>(
    [],
  )
  const [monthAndYear, setMonthAndYear] = useState<MonthAndYear>({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  })
  const [timeZone, setTimeZone] = useState<string>(useHints().timeZone)

  const setFormatMonthAndYear = (newDate: Date) => {
    setMonthAndYear({
      month: new Date(newDate).getMonth(),
      year: new Date(newDate).getFullYear(),
    })
  }

  useEffect(() => {
    let queryParams = buildQueryParams({
      professionalId: service.professional.id,
      serviceId: service.id,
      ...monthAndYear,
      sessionId: sessionToReschedule?.id,
      timeZone,
    })

    const getData = async () => {
      const response = await fetch(
        '/api/schedules/getByMonth?' + queryParams.toString(),
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )

      const data: any = await response.json()

      if (!data.error) {
        setAvailableDates(data.schedules)
      }
    }
    getData()
  }, [monthAndYear, timeZone])

  return {
    availableDates,
    monthAndYear,
    setFormatMonthAndYear,
    timeZone,
    setTimeZone,
  }
}

export default useMontlyParsedDates
